var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal_contain"},[_c('div',{staticClass:"title_top"},[_c('div'),_c('div',{staticClass:"modal_title"},[_vm._v("常见问题")]),_c('div',{staticClass:"modal_close",on:{"click":_vm.onClose}})]),_c('div',{staticClass:"modal_faq",domProps:{"innerHTML":_vm._s(_vm.content)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }